module.exports = __webpack_public_path__ + "img/116-curacao.516587e9.svg";